import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;

const yacurierEl = document.getElementById('yacurier-form');
if (yacurierEl) {
  new Vue({
    render: h => h(App),
  }).$mount('#yacurier-form');
}



// WEBPACK FOOTER //
// ./src/main.js